import './index.less';

const Logo = ({ src, className }) => {
    return <img src={src} className={`Logo ${className}`}/>;
};

export default Logo;
